import { API_APPOINTMENT, API_CONSULT, API_IAM } from 'Constants/client-modules';

import * as ACTION_TYPES from './types';

export function getFellowDoctors(params, isLoadMore = false) {
  return {
    types: [
      ACTION_TYPES.FELLOW_DOCTORS_GET_REQUESTED,
      ACTION_TYPES.FELLOW_DOCTORS_GET_SUCCEED,
      ACTION_TYPES.FELLOW_DOCTORS_GET_FAILED,
    ],
    promise: client => client.get('/v1.4/doctors/fellows', { params }),
    options: {
      clientName: API_APPOINTMENT,
    },
    meta: {
      isLoadMore,
    },
  };
}

export function getDoctors(params, isLoadMore = false, cancelToken) {
  return {
    types: [
      ACTION_TYPES.DOCTORS_GET_REQUESTED,
      ACTION_TYPES.DOCTORS_GET_SUCCEED,
      ACTION_TYPES.DOCTORS_GET_FAILED,
    ],
    promise: client => client.get('/doctors', { params, cancelToken }),
    options: {
      clientName: API_IAM,
    },
    meta: {
      isLoadMore,
    },
  };
}

export function getRecentDoctors(doctorId) {
  return {
    types: [
      ACTION_TYPES.DOCTORS_GET_RECENT_REQUESTED,
      ACTION_TYPES.DOCTORS_GET_RECENT_SUCCEED,
      ACTION_TYPES.DOCTORS_GET_RECENT_FAILED,
    ],
    promise: client => client.get(`/doctors/${doctorId}/referral-memos/recent-doctors`),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function resetDoctorState() {
  return {
    type: ACTION_TYPES.DOCTORS_RESET_STATE,
    payload: {},
  };
}

export function resetDoctorErrorsState() {
  return {
    type: ACTION_TYPES.DOCTORS_RESET_ERRORS,
    payload: {},
  };
}

export function getDoctorProfile() {
  return {
    types: [
      ACTION_TYPES.DOCTOR_GET_PROFILE_REQUESTED,
      ACTION_TYPES.DOCTOR_GET_PROFILE_SUCCEED,
      ACTION_TYPES.DOCTOR_GET_PROFILE_FAILED,
    ],
    promise: client => client.get('/doctors/me'),
    options: {
      clientName: API_IAM,
    },
  };
}

export function updateDoctorProfile(body) {
  return {
    types: [
      ACTION_TYPES.DOCTOR_UPDATE_PROFILE_REQUESTED,
      ACTION_TYPES.DOCTOR_UPDATE_PROFILE_SUCCEED,
      ACTION_TYPES.DOCTOR_UPDATE_PROFILE_FAILED,
    ],
    promise: client => client.patch('/doctors/me', body),
    options: {
      clientName: API_IAM,
    },
  };
}

export function updateBasicInfo(body) {
  return {
    types: [
      ACTION_TYPES.DOCTOR_UPDATE_INFO_REQUESTED,
      ACTION_TYPES.DOCTOR_UPDATE_INFO_SUCCEED,
      ACTION_TYPES.DOCTOR_UPDATE_INFO_FAILED,
    ],
    promise: client => client.put('/doctors/me/personal-information', body),
    options: {
      clientName: API_IAM,
    },
  };
}

export function updateColleges(body) {
  return {
    types: [
      ACTION_TYPES.DOCTOR_UPDATE_COLLEGES_REQUESTED,
      ACTION_TYPES.DOCTOR_UPDATE_COLLEGES_SUCCEED,
      ACTION_TYPES.DOCTOR_UPDATE_COLLEGES_FAILED,
    ],
    promise: client => client.put('/doctors/me/colleges', body),
    options: {
      clientName: API_IAM,
    },
  };
}

export function updateProfessions(body) {
  return {
    types: [
      ACTION_TYPES.DOCTOR_UPDATE_PROFESSIONS_REQUESTED,
      ACTION_TYPES.DOCTOR_UPDATE_PROFESSIONS_SUCCEED,
      ACTION_TYPES.DOCTOR_UPDATE_PROFESSIONS_FAILED,
    ],
    promise: client => client.put('/doctors/me/professions', body),
    options: {
      clientName: API_IAM,
    },
  };
}

export function updateCollege(id, body) {
  return {
    types: [
      ACTION_TYPES.DOCTOR_UPDATE_COLLEGE_REQUESTED,
      ACTION_TYPES.DOCTOR_UPDATE_COLLEGE_SUCCEED,
      ACTION_TYPES.DOCTOR_UPDATE_COLLEGE_FAILED,
    ],
    promise: client => client.put(`/doctors/me/colleges/${id}`, body),
    options: {
      clientName: API_IAM,
    },
  };
}

export function addCollege(body) {
  return {
    types: [
      ACTION_TYPES.DOCTOR_ADD_COLLEGE_REQUESTED,
      ACTION_TYPES.DOCTOR_ADD_COLLEGE_SUCCEED,
      ACTION_TYPES.DOCTOR_ADD_COLLEGE_FAILED,
    ],
    promise: client => client.post('/doctors/me/colleges', body),
    options: {
      clientName: API_IAM,
    },
  };
}

export function deleteCollege(id) {
  return {
    types: [
      ACTION_TYPES.DOCTOR_DELETE_COLLEGE_REQUESTED,
      ACTION_TYPES.DOCTOR_DELETE_COLLEGE_SUCCEED,
      ACTION_TYPES.DOCTOR_DELETE_COLLEGE_FAILED,
    ],
    promise: client => client.delete(`/doctors/me/colleges/${id}`),
    options: {
      clientName: API_IAM,
    },
    meta: {
      id,
    },
  };
}

export function updateQualifications(body) {
  return {
    types: [
      ACTION_TYPES.DOCTOR_UPDATE_QUALIFICATIONS_REQUESTED,
      ACTION_TYPES.DOCTOR_UPDATE_QUALIFICATIONS_SUCCEED,
      ACTION_TYPES.DOCTOR_UPDATE_QUALIFICATIONS_FAILED,
    ],
    promise: client => client.put('/doctors/me/qualifications', body),
    options: {
      clientName: API_IAM,
    },
  };
}

export function addQualification(body) {
  return {
    types: [
      ACTION_TYPES.DOCTOR_ADD_QUALIFICATION_REQUESTED,
      ACTION_TYPES.DOCTOR_ADD_QUALIFICATION_SUCCEED,
      ACTION_TYPES.DOCTOR_ADD_QUALIFICATION_FAILED,
    ],
    promise: client => client.post('/doctors/me/qualifications', body),
    options: {
      clientName: API_IAM,
    },
  };
}

export function updateQualification(id, body) {
  return {
    types: [
      ACTION_TYPES.DOCTOR_UPDATE_QUALIFICATION_REQUESTED,
      ACTION_TYPES.DOCTOR_UPDATE_QUALIFICATION_SUCCEED,
      ACTION_TYPES.DOCTOR_UPDATE_QUALIFICATION_FAILED,
    ],
    promise: client => client.put(`/doctors/me/qualifications/${id}`, body),
    options: {
      clientName: API_IAM,
    },
  };
}

export function deleteQualification(id) {
  return {
    types: [
      ACTION_TYPES.DOCTOR_DELETE_QUALIFICATION_REQUESTED,
      ACTION_TYPES.DOCTOR_DELETE_QUALIFICATION_SUCCEED,
      ACTION_TYPES.DOCTOR_DELETE_QUALIFICATION_FAILED,
    ],
    promise: client => client.delete(`/doctors/me/qualifications/${id}`),
    options: {
      clientName: API_IAM,
    },
    meta: {
      id,
    },
  };
}

export function getDoctorTitles() {
  return {
    types: [
      ACTION_TYPES.DOCTOR_TITLE_GET_REQUESTED,
      ACTION_TYPES.DOCTOR_TITLE_GET_SUCCEED,
      ACTION_TYPES.DOCTOR_TITLE_GET_FAILED,
    ],
    promise: client => client.get('/v1.3/doctor-titles'),
    options: {
      clientName: API_APPOINTMENT,
    },
  };
}

export function getDoctorPayout() {
  return {
    types: [
      ACTION_TYPES.DOCTOR_GET_PAYOUT_REQUESTED,
      ACTION_TYPES.DOCTOR_GET_PAYOUT_SUCCEED,
      ACTION_TYPES.DOCTOR_GET_PAYOUT_FAILED,
    ],
    promise: client => client.get('/doctors/me/payout'),
    options: {
      clientName: API_IAM,
    },
  };
}

export function getSpeciality(params) {
  return {
    types: [
      ACTION_TYPES.GET_SPECIALITY_REQUESTED,
      ACTION_TYPES.GET_SPECIALITY_SUCCEED,
      ACTION_TYPES.GET_SPECIALITY_FAILED,
    ],
    promise: client => client.get('/specialists', { params }),
    options: {
      clientName: API_IAM,
    },
  };
}

export function getSpecialties() {
  return {
    types: [
      ACTION_TYPES.DOCTORS_GET_SPECIALTIES_REQUESTED,
      ACTION_TYPES.DOCTORS_GET_SPECIALTIES_SUCCEED,
      ACTION_TYPES.DOCTORS_GET_SPECIALTIES_FAILED,
    ],
    promise: client => client.get('/specialties'),
    options: {
      clientName: API_IAM,
    },
  };
}

export function getSpecialist(specialistId) {
  return {
    types: [
      ACTION_TYPES.GET_SPECIALIST_REQUESTED,
      ACTION_TYPES.GET_SPECIALIST_SUCCEED,
      ACTION_TYPES.GET_SPECIALIST_FAILED,
    ],
    promise: client => client.get(`/specialists/${specialistId}/doctors`),
    options: {
      clientName: API_IAM,
    },
  };
}

export function updateCurrency(currency) {
  return {
    types: [
      ACTION_TYPES.DOCTOR_CURRENCY_REQUESTED,
      ACTION_TYPES.DOCTOR_CURRENCY_SUCCEED,
      ACTION_TYPES.DOCTOR_CURRENCY_FAILED,
    ],
    promise: client => client.put('/doctors/me/currency', { currency }),
    options: {
      clientName: API_IAM,
    },
  };
}

export function finishInitDoctor() {
  return {
    types: [
      ACTION_TYPES.DOCTOR_FINISH_INIT_REQUESTED,
      ACTION_TYPES.DOCTOR_FINISH_INIT_SUCCEED,
      ACTION_TYPES.DOCTOR_FINISH_INIT_FAILED,
    ],
    promise: client => client.patch('/doctors/me', { status: { finished_onboarding: true } }),
    options: {
      clientName: API_IAM,
    },
  };
}

export function updateProfession(id, body) {
  return {
    types: [
      ACTION_TYPES.DOCTOR_UPDATE_PROFESSION_REQUESTED,
      ACTION_TYPES.DOCTOR_UPDATE_PROFESSION_SUCCEED,
      ACTION_TYPES.DOCTOR_UPDATE_PROFESSION_FAILED,
    ],
    promise: client => client.put(`/doctors/me/professions/${id}`, body),
    options: {
      clientName: API_IAM,
    },
  };
}

export function addProfession(body) {
  return {
    types: [
      ACTION_TYPES.DOCTOR_ADD_PROFESSION_REQUESTED,
      ACTION_TYPES.DOCTOR_ADD_PROFESSION_SUCCEED,
      ACTION_TYPES.DOCTOR_ADD_PROFESSION_FAILED,
    ],
    promise: client => client.post('/doctors/me/professions', body),
    options: {
      clientName: API_IAM,
    },
  };
}

export function deleteProfession(id) {
  return {
    types: [
      ACTION_TYPES.DOCTOR_DELETE_PROFESSION_REQUESTED,
      ACTION_TYPES.DOCTOR_DELETE_PROFESSION_SUCCEED,
      ACTION_TYPES.DOCTOR_DELETE_PROFESSION_FAILED,
    ],
    promise: client => client.delete(`/doctors/me/professions/${id}`),
    options: {
      clientName: API_IAM,
    },
    meta: {
      id,
    },
  };
}

export function getWorkExperiences() {
  return {
    types: [
      ACTION_TYPES.GET_WORK_EXPERIENCES_REQUESTED,
      ACTION_TYPES.GET_WORK_EXPERIENCES_SUCCEED,
      ACTION_TYPES.GET_WORK_EXPERIENCES_FAILED,
    ],
    promise: client => client.get('/doctors/me/work-experiences'),
    options: {
      clientName: API_IAM,
    },
  };
}

export function createWorkExperience(body) {
  return {
    types: [
      ACTION_TYPES.CREATE_WORK_EXPERIENCE_REQUESTED,
      ACTION_TYPES.CREATE_WORK_EXPERIENCE_SUCCEED,
      ACTION_TYPES.CREATE_WORK_EXPERIENCE_FAILED,
    ],
    promise: client => client.post('/doctors/me/work-experiences', body),
    options: {
      clientName: API_IAM,
    },
  };
}

export function updateWorkExperience(workExperienceId, body) {
  return {
    types: [
      ACTION_TYPES.UPDATE_WORK_EXPERIENCE_REQUESTED,
      ACTION_TYPES.UPDATE_WORK_EXPERIENCE_SUCCEED,
      ACTION_TYPES.UPDATE_WORK_EXPERIENCE_FAILED,
    ],
    promise: client => client.put(`/doctors/me/work-experiences/${workExperienceId}`, body),
    options: {
      clientName: API_IAM,
    },
    meta: {
      id: workExperienceId,
    },
  };
}

export function deleteWorkExperience(workExperienceId) {
  return {
    types: [
      ACTION_TYPES.DELETE_WORK_EXPERIENCE_REQUESTED,
      ACTION_TYPES.DELETE_WORK_EXPERIENCE_SUCCEED,
      ACTION_TYPES.DELETE_WORK_EXPERIENCE_FAILED,
    ],
    promise: client => client.delete(`/doctors/me/work-experiences/${workExperienceId}`),
    options: {
      clientName: API_IAM,
    },
    meta: {
      id: workExperienceId,
    },
  };
}
